export type ApplicationQuestionType = 'text' | 'yes_no' | 'multiple_choice';

export function getApplicationQuestionTypeLabel(type: ApplicationQuestionType): string {
  switch (type) {
    case 'text':
      return 'Short Answer';
    case 'yes_no':
      return 'Yes / No';
    case 'multiple_choice':
      return 'Multiple Choice';
    default:
      return 'Unknown';
  }
}
